'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { Suspense } from 'react';

import { ReviewDetailSessionPortal } from '@/app/donation/_components/ReviewDetailSessionPortal';
import { useCustomRouter } from '@/hooks/useCustomRouter';

const DETAIL_REVIEW_ID = 'detailReviewId';

const ReviewDetailControllerComponent = () => {
  const router = useCustomRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const parsedReviewId = Number(searchParams.get(DETAIL_REVIEW_ID));
  const reviewId =
    Number.isInteger(parsedReviewId) && parsedReviewId > 0
      ? parsedReviewId
      : undefined;

  const handleClose = () => {
    const nextSearchParams = new URLSearchParams(searchParams.toString());
    nextSearchParams.delete(DETAIL_REVIEW_ID);

    const search = nextSearchParams.toString();

    router.replace(`${pathname}${search ? `?${search}` : ''}`, {
      scroll: false,
    });
  };

  return (
    <ReviewDetailSessionPortal
      open={Boolean(reviewId)}
      onClose={handleClose}
      reviewId={reviewId}
    />
  );
};

//* 경계가 없으면 정적 렌더의 useSearchParams가 loading.tsx까지 올라가 상세 본문 전체가 서버 HTML에서 빠진다
export const ReviewDetailController = () => (
  <Suspense fallback={null}>
    <ReviewDetailControllerComponent />
  </Suspense>
);
